import { IPageContext } from '../models'

let _cleanup: (() => void)[] = []
let _launchTime = Date.now()
let _pageContext: IPageContext = {}
let _rethrowExceptions = false
let _surfaceContainerId = ''

export const getLaunchTime = () => _launchTime
export const getPageContext = () => _pageContext
export const getRethrowExceptions = () => _rethrowExceptions
export const getSurfaceContainerId = () => _surfaceContainerId

export const setLaunchTime = (launchTime: number) => (_launchTime = launchTime)

export const setPageContext = (pageContext: IPageContext) =>
  (_pageContext = pageContext)

export const setRethrowExceptions = (rethrowExceptions: boolean) =>
  (_rethrowExceptions = rethrowExceptions)

export const setSurfaceContainerId = (surfaceContainerId: string) =>
  (_surfaceContainerId = surfaceContainerId)

export const pushCleanup = (cleanup: () => void) => _cleanup.push(cleanup)

export const runCleanup = () => {
  _cleanup.forEach(c => c())
  _cleanup = []
}
